import styled from 'styled-components';
import { palette } from 'styled-theme';
import WithDirection from '../../../config/withDirection';

const StyleWrapper = styled.div`
    align-self: center;
    input { display: none; }

    input:checked ~ label {
        border-color: rgba(12, 183, 148, 1);
        padding-left: 28px;
        background-color: rgba(12, 183, 148, 1);

        .running { display: block; }
        img.running { height: 13px; }
    }
    input:not(:checked) ~ label {
        .paused { display: block; }
        img.paused { height: 12px; }
    }

    label {
        display: inline-block;
        border: 2px solid rgba(229, 229, 229, 1);
        height: 43px;
        width: 71px;
        padding-left: 0;
        background-color: rgba(255, 255, 255, 1);
        cursor: pointer;
        border-radius: 39px;
        transition: padding-left .3s;

        span {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            height: 39px;
            width: 39px;
            background-color: rgba(255, 255, 255, 1);
            border: 1px solid rgba(0, 0, 0, 0.1);
            border-radius: 39px;
            box-shadow: 0px 4px 2px 0px rgba(0, 0, 0, 0.17);

            img { display: none; }
        }

        p {
            position: absolute;
            right: 0; bottom: -24px; left: 0;
            display: none;

            :after {
                display: block;
                content: attr(class);
                font-family: 'Montserrat';
                font-size: 12px;
                font-weight: 300;
                color: rgba(64,55,57,1);
                text-align: center;
                text-transform: uppercase;
                transform: translateY(100%;)
            }
            
            &.running:after { content: '运行中'; }
            &.paused:after { content: '暂停'; }
        }
        p.paused:after { color: rgba(170, 170, 170, 1); }
    }

    @media screen and (max-width: 991px) {
        @media screen and (min-width: 768px) {

            &:not(.breakdown) {
                display: flex;
                justify-content: center;
                width: 100%;
            }
        }
    }

    @media screen and (max-width: 480px) {
        flex-grow: 1;
        display: flex;
        justify-content: center;
    }
`;

export default WithDirection(StyleWrapper);


// WEBPACK FOOTER //
// ./src/containers/CampaignList/CampaignState/Wrapper.js